import React from 'react';
import Form from "react-bootstrap/Form";

const RecommendersInfo2Form = ({fields, handleFieldChange, messages, page, isEdit}) => {
  return (
    <>
      <h3>推薦者 （代議員2名）</h3>
      <dl>
        <dt>推薦者１</dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="recommender1" size="lg">
            <Form.Control
              type="text"
              name="recommender1"
              value={fields.recommender1}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="recommender1Message" className="errorMessages">{messages.recommender1.n}</p>
        </dd>

        <dt>推薦理由１</dt>
        <dd>
          <Form.Group controlId="reasonForRecommend1">
            <Form.Control
              as="textarea"
              value={fields.reasonForRecommend1}
              onChange={handleFieldChange}
              rows={3} />
          </Form.Group>
          <p>※会員の研究や活動への協力、学会への貢献など</p>
          <p id="reasonForRecommend1Message" className="errorMessages">{messages.reasonForRecommend1.n}</p>
        </dd>
        <dt>推薦者２</dt>
        <dd>
          <Form.Group className="inlineFormControl" controlId="recommender2" size="lg">
            <Form.Control
              type="text"
              name="recommender2"
              value={fields.recommender2}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="recommender2Message" className="errorMessages">{messages.recommender2.n}</p>
        </dd>

        <dt>推薦理由２</dt>
        <dd>
          <Form.Group controlId="reasonForRecommend2">
            <Form.Control
              as="textarea"
              value={fields.reasonForRecommend2}
              onChange={handleFieldChange}
              rows={3} />
          </Form.Group>
          <p>※会員の研究や活動への協力、学会への貢献など</p>
          <p id="reasonForRecommend2Message" className="errorMessages">{messages.reasonForRecommend2.n}</p>
        </dd>
      </dl>
    </>

  );
}

export default RecommendersInfo2Form;
